import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-294dd878"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ag-page_hashinsp position-relative" }
const _hoisted_2 = {
  class: "modal fade ag-modal ag-otp-modal",
  id: "threatPathModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "ag-modal",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-dialog-centered modal-lg",
  role: "document"
}
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "result" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex align-items-center flex-column w-100"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "border-0 ag-button ag-button_radius pr-4 pl-4 ag-button_primary float-inline-end",
    "data-dismiss": "modal"
  }, " Close ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_card = _resolveComponent("ag-card")!
  const _component_ag_loading = _resolveComponent("ag-loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ag_card, {
        module: _ctx.module,
        onSearch: _ctx.search,
        onMain: _ctx.mainLink,
        onExport: _ctx.getList,
        onExportend: _ctx.getList
      }, null, 8, ["module", "onSearch", "onMain", "onExport", "onExportend"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.threatPath.pathCount == 1 ? "Path" : "Paths"), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (!_ctx.pathLoading && _ctx.threatPath)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.threatPath.path, (item, index) => {
                          return (_openBlock(), _createElementBlock("p", {
                            class: "mt-3 d-flex align-items-center flex-column text-hover w-100",
                            key: index,
                            onClick: ($event: any) => (_ctx.copyPath(item))
                          }, _toDisplayString(item), 9, _hoisted_11))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.pathLoading)
                ? (_openBlock(), _createBlock(_component_ag_loading, { key: 1 }))
                : _createCommentVNode("", true)
            ]),
            _hoisted_12
          ])
        ])
      ])
    ])
  ], 64))
}